import { Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';

export const StyledTableCell = styled(TableCell)({
  [`&.${tableCellClasses.head}`]: {
    fontWeight: 'bold',
    fontSize: 16,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
});

export const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover,
  },
}));

export const DashboardErrorLogsTitle = styled(Typography)(({ theme }) => ({
  fontSize: '32px',
  display: 'flex',
  color: theme.palette.primary.main,
  fontWeight: 'bold',
  alignItems: 'flex-end',
  marginLeft: '4px',
}));
